import store from '@/store';

export default class BrokerErrorEvent {
  constructor(message) {
    const errorMessage = this.formatTextToTranslate(message.reason);

    const replaces = {};

    Object.keys(message.errorDetails).forEach((key) => {
      const replaceKey = this.formatTextToTranslate(key);
      replaces[replaceKey] = message.errorDetails[key];
    });

    store.dispatch('showSnackbar', {
      text: errorMessage,
      replaces,
      type: 'error',
    });
  }

  formatTextToTranslate(message) {
    const text = message
      .toLowerCase()
      .split('_')
      .map((str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
      })
      .join('');

    return text.charAt(0).toLowerCase() + text.slice(1);
  }
}
